import { SuccessReturnBody, getSuccessReturnBody } from '../general';
import { Source } from '../../types/fromDb/Sources/source';

export function getSourcesReturnBody(body: Source[]): SuccessReturnBody {
  return getSuccessReturnBody(body)
}
